var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 33,
    height: 32,
    rx: 5,
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8438 16.4531C25.7344 12.3125 21.5156 9.5 16.75 9.5C11.9453 9.5 7.72656 12.3125 5.61719 16.4531C5.53906 16.6094 5.5 16.8047 5.5 17C5.5 17.2344 5.53906 17.4297 5.61719 17.5859C7.72656 21.7266 11.9453 24.5 16.75 24.5C21.5156 24.5 25.7344 21.7266 27.8438 17.5859C27.9219 17.4297 27.9609 17.2344 27.9609 17.0391C27.9609 16.8047 27.9219 16.6094 27.8438 16.4531ZM16.75 22.625C13.625 22.625 11.125 20.125 11.125 17C11.125 13.9141 13.625 11.375 16.75 11.375C19.8359 11.375 22.375 13.9141 22.375 17V17.0391C22.375 20.125 19.8359 22.6641 16.75 22.6641V22.625ZM16.75 13.25C16.3984 13.2891 16.0469 13.3281 15.7344 13.4062C15.9688 13.7188 16.0859 14.1094 16.0859 14.5391C16.0859 15.5547 15.2656 16.375 14.25 16.375C13.8203 16.375 13.4297 16.2578 13.1172 16.0234C13.0391 16.3359 13 16.6875 13 17C13 19.0703 14.6797 20.75 16.75 20.75C18.8203 20.75 20.5 19.0703 20.5 17C20.5 14.9297 18.8203 13.2891 16.75 13.2891V13.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.d5b01b295588c15c1f902e31bf6e8d34.svg";
export { ForwardRef as ReactComponent };